import React, { useState, useCallback } from "react";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import FormGroup from "@material-ui/core/FormGroup";
import IconButton from "@material-ui/core/IconButton";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";

import { useGlobalState, useGlobalUpdater } from "../common/GlobalContext";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    maxWidth: 400,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  colselectLabel: {
    paddingRight: 15,
  },
  colselectColumn2: {
    paddingLeft: 15,
  },
}));

export default function TableColumnSelector(props) {
  const classes = useStyles();
  const query = useGlobalState();
  const dispatch = useGlobalUpdater();

  const [dialogWidth, setDialogWidth] = useState("lg");
  const handleClickOpen = () => props.setOpen(true);
  const handleClose = () => props.setOpen(false);

  // Derive columns + dispatchType from current state
  const isTop100 = query.layerSpecs.category === "Top 100";
  const columns = isTop100 ? query.tableColumnsTop100 : query.tableColumnsHPMS;
  const dispatchType = isTop100 ? "setTableColumnsTop100" : "setTableColumnsHPMS";



 const updateColumns = useCallback((updaterFn) => {
  dispatch({
    type: dispatchType,
    selection: updaterFn(columns),
  });
}, [columns, dispatch, dispatchType]);

  const handleChange = (event) => {
    const { name, checked } = event.target;
    updateColumns((cols) =>
      cols.map((itm) => {
        if (itm.id === name) return { ...itm, checked };
        // trkvolper requires aadt + trkaadt
        if (name === "trkvolper" && checked && (itm.id === "aadt" || itm.id === "trkaadt"))
          return { ...itm, checked: true };
        return itm;
      })
    );
  };

const makeSelectAll = useCallback((category, state) => () =>
  updateColumns((cols) =>
    cols.map((itm) => itm.category === category ? { ...itm, checked: state } : itm)
  ), [updateColumns]);


const handleSelectAllColumnsAll     = makeSelectAll("all", true);
const handleUnselectAllColumnsAll   = makeSelectAll("all", false);
const handleSelectAllColumnsTruck   = makeSelectAll("truck", true);
const handleUnselectAllColumnsTruck = makeSelectAll("truck", false);
const handleSelectAllColumnsOther   = makeSelectAll("other", true);
const handleUnselectAllColumnsOther = makeSelectAll("other", false);


  function DialogColumn(props) {
    return (
      <div>
        <FormGroup
          key={props.formGroupKey}
          className={classes.colselectColumn2}
        >
          <FormLabel component="legend" className={classes.colselectLabel}>
            {props.categoryLabel}
          </FormLabel>
          {columns
            .filter((item) => item.category === props.category)
            .map((col, index) => (
              <FormControlLabel
                control={
                  <Checkbox
                    name={col.id}
                    key={`check-rdsegment-col-${index}`}
                    checked={col.checked}
                    onChange={handleChange}
                  />
                }
                label={col.label}
                key={`check-rdsegment-col-fgl-${index}`}
              />
            ))}
          <Grid
            container
            alignItems="center"
            className={classes.colselectLabel}
          >
            {props.selectAllButton !== "none" && (
              <Grid item xs>
                <Button onClick={props.selectAllButton} color="secondary">
                  Select All
                </Button>
              </Grid>
            )}
            {props.unselectAllButton !== "none" && (
              <Grid item>
                <Button onClick={props.unselectAllButton} color="secondary">
                  Unselect All
                </Button>
              </Grid>
            )}
          </Grid>
        </FormGroup>
      </div>
    );
  }

  return (
    <div>
      <HtmlTooltip placement="top-start" title="Select data table columns">
        <IconButton
          component="span"
          color="secondary"
          aria-label="select columns"
          onClick={handleClickOpen}
        >
          <ViewColumnIcon />
        </IconButton>
      </HtmlTooltip>
      <Dialog
        open={props.open}
        onClose={handleClose}
        fullWidth
        maxWidth={dialogWidth}
      >
        <DialogTitle>Select table columns below:</DialogTitle>
        <DialogContent>
          <Grid container alignItems="flex-start">
            <DialogColumn
              formGroupKey={`check-rdsegment-col-fg1`}
              category={"route"}
              categoryLabel={"Route Information"}
              selectAllButton={"none"}
              unselectAllButton={"none"}
            />
            <Divider orientation="vertical" flexItem />
            <DialogColumn
              formGroupKey={`check-rdsegment-col-fg2`}
              category={"all"}
              categoryLabel={"All Vehicle Performance Measures"}
              selectAllButton={handleSelectAllColumnsAll}
              unselectAllButton={handleUnselectAllColumnsAll}
            />
            <Divider orientation="vertical" flexItem />
            <DialogColumn
              formGroupKey={`check-rdsegment-col-fg3`}
              category={"truck"}
              categoryLabel={"Truck Performance Measures"}
              selectAllButton={handleSelectAllColumnsTruck}
              unselectAllButton={handleUnselectAllColumnsTruck}
            />
            <Divider orientation="vertical" flexItem />

            <DialogColumn
              formGroupKey={`check-rdsegment-col-fg4`}
              category={"other"}
              categoryLabel={"Other Measures"}
              selectAllButton={handleSelectAllColumnsOther}
              unselectAllButton={handleUnselectAllColumnsOther}
            />
          </Grid>
          <Divider variant="middle" />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
